// Imports
import React, { useEffect, useState } from 'react';
// Contents
import Link from "../menu-link/LinkHelper";
import { l } from "../../lang/index.jsx";
import { useLenis } from "lenis/react";
import { supabase } from '../../utils/supabase.js';

const FooterMenu = React.memo(({ navigate, lang }) => {

    const [contentMap, setContentMap] = useState(null);

    useEffect(() => {
        supabase.from('footer_content').select('key, fr, en')
            .then(({ data }) => {
                if (data) {
                    const map = {};
                    data.forEach(r => { map[r.key] = { fr: r.fr, en: r.en }; });
                    setContentMap(map);
                }
            });
    }, []);

    const t = (key) => contentMap?.[key]?.[lang] || l(key, lang);

    const lenis = useLenis();

    const scrollTop = () => {
        if (lenis) {
            lenis.scrollTo(0, {
                delay: 1,
                duration: 3,
                immediate: false,
                ease: "power4.inOut"
            })
        }
    }

    return (
        <footer className='section section-footer'>
            <div className='footer-block'>
                <div className='footer-inner'>
                    <div className='footer-element'>
                        <div>
                            <div className='footer-logo'>
                                <Link navigate={navigate} className="link" href="/" aria-label="Go to homepage">
                                    <svg id="Calque_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.36 94.36">
                                        <defs>
                                            <style>{`.cls-1{fill:#fcfbe9;}.cls-2{fill:#eb661b;}`}</style>
                                        </defs>
                                        <g id="Calque_1-2">
                                            <g>
                                                <rect className="cls-2" x="12.71" y="41.73" width="32.45" height="10.91"
                                                      transform="translate(57.86 94.36) rotate(180)"/>
                                                <rect className="cls-2" x="26.2" y="31.73" width="30.89" height="10.91"
                                                      transform="translate(78.84 -4.46) rotate(90)"/>
                                                <path className="cls-2" d="M47.05,55.2h-10.86c0,5.49,4.26,14.54,10.86,17.42v-17.42Z"/>
                                                <path className="cls-1"
                                                      d="M0,47.18c0,9.12,2.61,17.64,7.11,24.87V22.31C2.61,29.54,0,38.06,0,47.18Z"/>
                                                <path className="cls-1"
                                                      d="M47.18,10.89c14.16,0,26.44,8.16,32.42,20.01h11.86C84.82,12.88,67.48,0,47.18,0c-9.54,0-18.42,2.86-25.85,7.74v14c6.59-6.69,15.74-10.85,25.85-10.85Z"/>
                                                <path className="cls-1"
                                                      d="M94.05,41.84v-.08s0,0,0,0h-31.41v10.85h20.44c-2.63,17.45-17.72,30.86-35.88,30.86-10.11,0-19.27-4.16-25.85-10.85v14c7.43,4.89,16.31,7.74,25.85,7.74,26.02,0,47.18-21.16,47.18-47.18,0-1.81-.12-3.59-.31-5.35Z"/>
                                                <path className="cls-2"
                                                      d="M21.33,72.62V21.74c-6.45,6.55-10.44,15.54-10.44,25.44s3.99,18.88,10.44,25.44Z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </Link>
                            </div>
                            <div className='text-group'>
                                <span>{t('footer-place')}</span>
                            </div>
                        </div>
                        <div className="arrow-container event-cursor">
                            <svg id='returnTop' onClick={scrollTop} className="arrow-up" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                            </svg>
                        </div>
                    </div>
                    <div className='droits'>
                        <p>{t('footer-rights')}</p>
                    </div>
                </div>
            </div>
        </footer>
    )
})

export default FooterMenu
